// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2181":"dbba44b9","3968":"0b390afe"}[chunkId] + ".chunk.css";
};